import '../lib/lightcase.js';
import mobileMenu from '../lib/mobile-menu';
import header from '../lib/header';
import mobileFilterNav from '../lib/mobile-filter-nav';
import carousels from '../lib/carousels';
import Capabilities from '../blocks/our-cababilities';
import animation from '../lib/animation';
import LazyLoad from '../lib/lazy-load';
import SupplierForm from '../blocks/supplier-form';
import InteractiveCuts from '../blocks/interactive-cuts';
//import LazyLoad from "vanilla-lazyload";

export default {
  init() {
    /**
     * Init LightCase
     */
    $('a[data-rel^=lightcase]').lightcase();

    /**
     * Init Mobile Menu
     */
    mobileMenu.init();

    /**
     * Init Header
     */
    header.init();

    /**
     * Init Mobile Filter Navigation
     */
    mobileFilterNav.init();


    /**
     * Init Carousels
     */
    carousels.init();

     /**
     * Init LazyLoading
     */
    new LazyLoad();


    /**
     * Init Capabilities Module
     */
    new Capabilities();

     /**
     * Init SupplierForm
     */
    new SupplierForm();


    /**
     * Init Interactive Cuts
     */
    let elements = document.querySelectorAll('.cuts');
    if( typeof(elements) != 'undefined' && elements != null ) {
      new InteractiveCuts();
    }

      /**
     * Open boxes when anchor is present
     **/
      $(".hidden-anchor").each(function(el) {
        $(el).addClass('hide');
      });
      $( window ).on('hashchange', function() {
        if($(location.hash) && $(location.hash).hasClass('hidden-anchor')) {
          showHiddenAnchor(location.hash);
        }
      });
      $( window ).trigger('hashchange');

      function showHiddenAnchor(show) {
        $(".hidden-anchor").each(function(el) {
          $(el).addClass('hide');
        });

        $(show).removeClass('hide');
      }


    /**
     * Prevent Orphan Words in CTA's and titles
     **/
    $(".call-to-action__text, .heading-text__text p, .call-to-action__title").each(function() {

      var wordArray = $(this).text().trim().split(" ");
      if (wordArray.length > 1) {
        wordArray[wordArray.length-2] += "&nbsp;" + wordArray[wordArray.length-1];
        wordArray.pop();
        $(this).html(wordArray.join(" "));
      }
    });

    /**
     * Smart Crop Images
     */
    // update smart crop in tabs.
    $('.tabs__accordion-link').on('click', function () {
        $('.tab-col .wpsmartcrop-overlay').removeClass('wpsmartcrop-overlay-rendered');
        window.dispatchEvent( new Event('resize') );
    });

    /**
     * Wrap blockquote with text if a preceding paragraph is present.
     */
    $('.wp-block-quote, .wp-block-quote + p').wrapAll("<div class='block-quote-wrapper' />");


    /**
     * Init Animation
     */
    animation.init();
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js